import { SEARCHTASK_SUCCESS, SEARCHTASK_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const searchTaskReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCHTASK_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SEARCHTASK_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default searchTaskReducer;
